import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Import Images
import aboutThumb1 from '../../images/about/pic-1.jpg';
import aboutThumb2 from '../../images/about/pic-2.jpg';
import aboutThumb3 from '../../images/about/pic-3.jpg';
import feat1 from '../../images/feature-1.png';
import feat2 from '../../images/feature-2.png';
import feat3 from '../../images/feature-3.png';
import feat4 from '../../images/feature-4.png';

class aboutSection extends Component{
	render(){
		return(
			<>
				<section className="section-sp1 about-area">
					<div className="container">
						<div className="row align-items-center">
							<div className="col-lg-6 mb-30">
								<div className="about-thumb-area">
									<ul>
										<li><img className="about-thumb1" src={aboutThumb1} alt=""/></li>
										<li><img className="about-thumb2" src={aboutThumb2} alt=""/></li>
										<li><img className="about-thumb3" src={aboutThumb3} alt=""/></li>
										<li><div className="exp-bx">+10<span>Años de experiencia</span></div></li>
									</ul>
								</div>
							</div>
							<div className="col-lg-6 mb-30">
								<div className="heading-bx">
									<h6 className="title-ext text-secondary">Nosotros</h6>
									<h2 className="title">Nuestra prioridad sos vos</h2>
									<p>Somos un equipo multidisciplinario enfocados en devolver salud y funcionalidad con diagnósticos adecuados a tus necesidades, acá encontraras:</p>
								</div>
								<div className="row">
									
									<div className="col-lg-6 col-sm-6 mb-30 mb-sm-20">
										
										<div className="feature-container feature-bx1 feature1">
											<div className="icon-md">
												<span className="icon-cell">
													<img src={feat1} alt=""/>
												</span> 
											</div>
											<div className="icon-content">
												<h4 className="ttr-title">Diagnóstico claro y honesto</h4>
											</div>
										</div>
									</div>
									<div className="col-lg-6 col-sm-6 mb-30 mb-sm-20">
										<div className="feature-container feature-bx1 feature2">
											<div className="icon-md">
												<span className="icon-cell">
													<img src={feat2} alt=""/>
												</span> 
											</div>
											<div className="icon-content">
												<h4 className="ttr-title">Especialistas que te escuchan</h4>
											</div>
										</div>
									</div>
									<div className="col-lg-6 col-sm-6 mb-30 mb-sm-20">
										<div className="feature-container feature-bx1 feature3">
											<div className="icon-md">
												<span className="icon-cell">
													<img src={feat3} alt=""/>
												</span> 
											</div>
											<div className="icon-content">
												<h4 className="ttr-title">Cuidados pensados para vos</h4>
											</div>
										</div>
									</div>
									<div className="col-lg-6 col-sm-6 mb-30 mb-sm-20">
										<div className="feature-container feature-bx1 feature4">
											<div className="icon-md">
												<span className="icon-cell">
												<img src={feat4} alt=""/>
												</span> 
											</div>
											<div className="icon-content">
												<h4 className="ttr-title">Acompañamiento en cada paso</h4>
											</div>
										</div>
									</div>
								</div>
								
							</div>
						</div>
					</div>
					
				</section>
				
			</>
		);
	}
}

export default aboutSection;